
import Router from './RouterComponent/Router';



function App() {
  return (
    <div >  
   <Router/>
    </div>
  );
}

export default App;
